// src/lib/gtag.js
export const GA_TRACKING_ID = "G-M7PKJ3LEDC";

export const pageview = (url) => {
  if (window.gtag) {
    window.gtag("config", GA_TRACKING_ID, {
      page_path: url,
    });
  }
};
